import { render, staticRenderFns } from "./DomainTransferView.vue?vue&type=template&id=6bcd59ae&"
import script from "./DomainTransferView.vue?vue&type=script&lang=js&"
export * from "./DomainTransferView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bcd59ae')) {
      api.createRecord('6bcd59ae', component.options)
    } else {
      api.reload('6bcd59ae', component.options)
    }
    module.hot.accept("./DomainTransferView.vue?vue&type=template&id=6bcd59ae&", function () {
      api.rerender('6bcd59ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/domains/DomainTransferView.vue"
export default component.exports